import { SEARCH_PARAM_SITE_ID } from 'routes/(global_search_params)/-searchParams'
import { z } from 'zod'

export const SEARCH_PARAM_DETECTION_CONFIGURATION_ID =
  'detectionConfigurationId'

export const detectionConfigurationSearchParams = z.object({
  [SEARCH_PARAM_SITE_ID]: z.string(),
  [SEARCH_PARAM_DETECTION_CONFIGURATION_ID]: z.string(),
})
